import React from 'react';

import {InlineBannerType} from 'ui-library/banners/InlineBanner';
import {ExpandableModal} from 'ui-library/modals/ExpandableModal';

export interface ChemSearchModalFrameProps {
  title: string;
  showHeaderBorder?: boolean;
  submitError: string | null;
  onRequestClose: () => void;
  onRequestSubmit: () => void;
  children: React.ReactNode;
}

export default function ChemSearchModalFrame({
  title,
  showHeaderBorder = true,
  submitError,
  onRequestClose,
  onRequestSubmit,
  children,
}: ChemSearchModalFrameProps): JSX.Element {
  return (
    <ExpandableModal
      bodyPadded={false}
      enableRedesign={true}
      showHeaderBorder={showHeaderBorder}
      title={title}
      bannerProps={submitError != null ? {bannerType: InlineBannerType.ERROR, text: submitError} : null}
      buttons={[
        {
          text: 'Search',
          submit: true,
          dataTestAttrs: {component: 'ChemSearchModal', element: 'submit'},
        },
      ]}
      onRequestClose={onRequestClose}
      onRequestSubmit={onRequestSubmit}
      expandHeight={true}
      scrollable={true}
    >
      {children}
    </ExpandableModal>
  );
}
